export default __webpack_public_path__ + "static/media/logo-opim.c26a575a.svg";